import { createFeatureSelector, createSelector } from '@ngrx/store';

import { KN_BR_QUOTE_REFERENCE_FEATURE, KnBrQuoteReferenceState } from './kn-br-quote-reference.state';

export const getQuoteReferenceState = createFeatureSelector<KnBrQuoteReferenceState>(KN_BR_QUOTE_REFERENCE_FEATURE);
export const getQuoteReference = createSelector(
  getQuoteReferenceState,
  (state: KnBrQuoteReferenceState) => state.referenceResponse?.orderEntries
);
